export default __webpack_public_path__ + "static/media/bolt-alt.69cce593.svg";